import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';
import grey from '@material-ui/core/colors/grey';
import amber from '@material-ui/core/colors/amber';

import {
  Filter,
  FilterButton,
  FilterDivider,
  FilterItem,
} from 'components/core/Filter';

import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';
import { startEditAdmin } from 'store/actions/admin';
import { startAddBid } from '../../../store/actions/bids';
import { startAddInvoice } from '../../../store/actions/invoices';
import { startEditInvoiceListFilter } from '../../../store/actions/filters';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  addButton: {
    backgroundColor: amber[500],
    color: "#fff",
    marginLeft: theme.spacing.unit*4,
  },
  helpOverlay: {
    zIndex: theme.zIndex.overlay + 1,
  },
});

const InvoiceFilters = (props) => {
  const {
    classes,
    invoiceListFilter,
    startAddBid,
    startAddInvoice,
    startEditInvoiceListFilter,
    startEditAdmin
  } = props;

  return(
    <div className={classes.root}>
      <Filter>
        <FilterItem>
          <FilterButton
            selected={invoiceListFilter.type === "all"}
            onClick={() => startEditInvoiceListFilter({type: "all"})}>
            All
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Filter">
          <FilterButton
            selected={invoiceListFilter.type === "pending"}
            onClick={() => startEditInvoiceListFilter({type: "pending"})}>
            Pending
          </FilterButton>
          <FilterButton
            selected={invoiceListFilter.type === "overdue"}
            onClick={() => startEditInvoiceListFilter({type: "overdue"})}>
            Overdue
          </FilterButton>
          <FilterButton
            selected={invoiceListFilter.type === "outstanding"}
            onClick={() => startEditInvoiceListFilter({type: "outstanding"})}>
            Outstanding
          </FilterButton>
          <FilterButton
            selected={invoiceListFilter.type === "draft"}
            onClick={() => startEditInvoiceListFilter({type: "draft"})}>
            Draft
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Sort">
          <FilterButton
            selected={invoiceListFilter.orderBy === "date"}
            onClick={() => {
              let direction = "asc";
              if (invoiceListFilter.orderBy === "date") {
                direction = invoiceListFilter.direction === "asc" ? "desc" : "asc";
              }
              startEditInvoiceListFilter({orderBy: "date", direction: direction})
            }}>
            Date
          </FilterButton>
          <FilterButton
            selected={invoiceListFilter.orderBy === "client"}
            onClick={() => {
              let direction = "asc";
              if (invoiceListFilter.orderBy === "client") {
                direction = invoiceListFilter.direction === "asc" ? "desc" : "asc";
              }
              startEditInvoiceListFilter({orderBy: "client", direction: direction})
            }}>
            Client
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem hideCaption>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={invoiceListFilter.showArchived}
                onChange={() => {
                  startEditInvoiceListFilter({showArchived: !invoiceListFilter.showArchived})
                }}
              />
            }
            label="SHOW ARCHIVED"
          />
        </FilterItem>
      </Filter>

      <Tooltip type={TooltipTypes.ADD_INVOICE} placement="left">
          <Button
            id={TooltipTypes.ADD_INVOICE}
            className={classNames(classes.addButton, classes.helpOverlay)}
            variant="fab"
            aria-label="add"
            onClick={() => {
              startAddInvoice({})
                .then((invoice) => startEditAdmin({ invoice: invoice }))
                .then(() => helpDispatch(TooltipTypes.ADD_INVOICE))
            }}>
            <AddIcon />
          </Button>
      </Tooltip>
    </div>
  );
};

InvoiceFilters.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const invoiceListFilter = state.filters.invoiceList ? state.filters.invoiceList : {};
  return({
    invoiceListFilter,
  });
};

const mapDispatchToProps = {
  startAddInvoice,
  startEditInvoiceListFilter,
  startEditAdmin
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(InvoiceFilters);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/InvoiceFilters.jsx